module.exports = __webpack_public_path__ + "img/Picture16.7a65fcbf.png";